<div class="modal-header">
    <h4 class="modal-title">{{ isNew ? 'Add Batch Consumer' : 'Edit Batch Consumer' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    @if (errorMessage) {
        <div class="alert alert-danger py-1 px-2 mb-2">{{ errorMessage }}</div>
    }
    <form #batchConsumerForm="ngForm">
        <!-- Request Source -->
        <div class="form-group row mb5">
            <label for="requestSource" class="col-sm-3 col-form-label">Request Source <span class="req-color">*</span></label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="requestSource" name="requestSource"
                    [(ngModel)]="model.requestSource" [readonly]="!isNew" required>
            </div>
        </div>

        <!-- Service Bus Namespace -->
        <div class="form-group row mb5">
            <label for="serviceBusNamespace" class="col-sm-3 col-form-label">Service Bus Namespace</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="serviceBusNamespace" name="serviceBusNamespace"
                    [(ngModel)]="model.serviceBusNamespace">
            </div>
        </div>

        <!-- Service Bus Queue -->
        <div class="form-group row mb5">
            <label for="serviceBusQueue" class="col-sm-3 col-form-label">Service Bus Queue</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="serviceBusQueue" name="serviceBusQueue"
                    [(ngModel)]="model.serviceBusQueue">
            </div>
        </div>

        <!-- Event Type Suffix -->
        <div class="form-group row mb5">
            <label for="eventTypeSuffix" class="col-sm-3 col-form-label">Event Type Suffix</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="eventTypeSuffix" name="eventTypeSuffix"
                    [(ngModel)]="model.eventTypeSuffix">
            </div>
        </div>

        <!-- Is Active -->
        <div class="form-group row mb5">
            <label for="isActive" class="col-sm-3 col-form-label">Active</label>
            <div class="col-sm-9 d-flex align-items-center">
                <input type="checkbox" class="form-check-input" id="isActive" name="isActive"
                    [(ngModel)]="model.isActive">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()"
        [disabled]="isSaving || !batchConsumerForm.valid">
        @if (isSaving) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        Save
    </button>
</div>
